import { render, staticRenderFns } from "./FarmWithdrawDialog.vue?vue&type=template&id=2991e232&scoped=true&"
import script from "./FarmWithdrawDialog.vue?vue&type=script&lang=ts&"
export * from "./FarmWithdrawDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FarmWithdrawDialog.vue?vue&type=style&index=0&id=2991e232&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991e232",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QSelect});qInstall(component, 'directives', {ClosePopup});
